export default {"src":"/_next/static/media/searchOutlined.70aeaf0c.svg","height":28,"width":30,"blurWidth":0,"blurHeight":0};